import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import ListadoRecursos from "../../components/carrusel/UserRecursosDestacados";
import "./css/MapaRecursos.css";

const Recursos = () => {
  
  const { role } = useSelector((state) => state.auth);
    const [categoria, setCategoria] = useState("destacadas");

  return (
    <>
        <Navbar />
        
        <main className="main mapa-recursos">
          
          {/* Botones crear ofertas y recursos */}
          {(role === "administrador" || role === "tecnico-1") && (
            <Link to="/admin/nuevo-recurso-interes" className="naranja align-center boton mb-50 w-content">Dar de alta un recurso de interés</Link>
          )}

          {/* Listado Recursos con filtros */}
          <section className="recursos-destacados">
            <h1 className="titulo-user align-center">
              <span className="titulo-user align-center gap-10">RECURSOS DE INTERÉS 
                <select
                  aria-label="Filtrados por"
                  className="desplegable-empleo mayusculas" 
                  value={categoria} 
                  onChange={(e) => setCategoria(e.target.value)}
                >
                  <option value="destacadas">DESTACADOS</option>
                  <option value="empleo">sobre empleo</option>
                  <option value="formacion">sobre formación</option>
                  <option value="social">social</option>
                  <option value="otros">otros</option>
                  <option value="todas">TODOS</option>
                </select>
              </span>
            </h1>
            <ListadoRecursos categoria={categoria}/>  
          </section>

        </main>
    </>
  );
};

export default Recursos;